import * as React from 'react';

type Props = {
  children: any;
  innerStyle?: React.CSSProperties;
  open: boolean;
  shave?: number;
  style?: React.CSSProperties;
};

const Collapser = (props: Props) => {
  return (
    <div style={props.style}>
      <div
        style={{...props.innerStyle, display: props.open ? 'block' : 'none'}}
      >
        {props.children}
      </div>
    </div>
  );
};

export default Collapser;
